import { getTrainingProductData, TrainingProductParameter } from "@crescentParts/Services/TrainingRegistrationService";
import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { TrainingProductDetailModel } from "@crescentParts/Widgets/CustomApiModels";
import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = TrainingProductParameter & HasOnSuccess<TrainingProductDetailModel>;

type Props = {
    apiParameter: Parameter;
    apiResult: TrainingProductDetailModel;
};

type HandlerType = CustomHandler<Parameter, Props>

export const DispatchBeginTrainingProduct: HandlerType = props => {
    props.dispatch({
        type: "Custom/TrainingProduct/BeginTrainingProducty"
    });
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getTrainingProductData(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteTrainingProduct: HandlerType = props => {
    props.dispatch({
        type: "Custom/TrainingProduct/CompleteTrainingProduct"
    });
};

export const chain = [DispatchBeginTrainingProduct, SendDataToApi, ExecuteOnSuccessCallback, DispatchCompleteTrainingProduct];

const getTrainingProduct = createHandlerChainRunner(chain, "getTrainingProduct");
export default getTrainingProduct;
